import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class HstdInitUrl extends Entity<HstdInitUrl>
{
    @Expose()
    url!: string
}
